<template>
    <Head title="Nouveau message"/>

    <AppLayout>
        <div class="p-6">
            <h1 class="text-xl font-bold mb-5">Modifier le message</h1>

            <form @submit.prevent="submit">
                <Form
                    :form="form"
                    :types="types"
                    :roles="roles"
                    :actions="actions"
                    :packages="packages"
                    :travels="travels"
                    :importances="importances"
                    :current-image="message.image"
                />

                <div class="mt-6 flex justify-end">
                    <BotiButton @click="submit" :text="'Mettre à jour'" :loader="form.processing" />
                </div>
            </form>
        </div>
    </AppLayout>
</template>

<script>
    import Form from './Form.vue'
    import BotiButton from '@/Components/Button'
    import { Head } from '@inertiajs/inertia-vue3'
    import AppLayout from '@/Layouts/AppLayout.vue'

    export default {
        components:{
            Head,
            Form,
            AppLayout,
            BotiButton
        },

        props:[
            'types',
            'roles',
            'actions',
            'packages',
            'travels',
            'message',
            'importances'
        ],

        data(){
            return {
                form:this.$inertia.form({
                    ...this.message,
                    starts_at: this.message.starts_at ?? null,
                    ends_at: this.message.ends_at ?? null,
                    min_app_version: this.message.min_app_version ?? null,
                    max_app_version: this.message.max_app_version ?? null,
                    image:null
                })
            }
        },

        methods:{
            submit(){
                this.form
                .transform(data=>({
                    ...data,
                    _method:'PUT'
                }))
                .post(route('app-messages.update', this.message.id), {
                    forceFormData:true
                })
            }
        }
    }
</script>